import React, { Fragment, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
import { getNextEpisode } from "@store/action/planning/EpisodeAction";
import { useDispatch, useSelector } from "react-redux";
import { getBanner } from "@store/action/smartend/BannerAction";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { secondsToTime } from "@store/action/GlobalAction";
import { Spinner } from "reactstrap";
import { PauseCircle } from "react-feather";
import Janus from "janus-gateway";
import adapter from "webrtc-adapter";
import TuneInChat from "@src/@core/components/customizer/TuneInChat";
import { useIcecast } from "@hooks/useIcecast";

SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  centeredSlides: true,
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },
  pagination: false,
  navigation: false,
};
const REACT_APP_JANUS_SERVER = process.env.REACT_APP_JANUS_SERVER;

const Banner = ({
  playerPause,
  isPaused,
  isloadind,
  setIsloadind,
  RadioReducer,
}) => {
  const radio_id = localStorage.getItem("radio_id");
  const dispatch = useDispatch();
  const { icecastData, host } = useIcecast();
  const onAir =
    icecastData?.artist === "live" && icecastData?.title.startsWith(host);
  const BannerReducer = useSelector((state) => state.BannerReducer);
  const episodeReducer = useSelector((state) => state.episodes);
  const next_episode = episodeReducer?.next;
  const music_icecast = RadioReducer?.single?.icecast_url_streaming;
  const music_hls = RadioReducer?.single?.hls_url_streaming;
  const tuneIn_player = document.getElementById("tuneIn_player");
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const namesong = PlayerFrontOfficeReducer.namesong;
  useEffect(() => {
    dispatch(getBanner({ per_page: 1000 }));
    dispatch(getNextEpisode());
  }, [dispatch]);
  const data = {
    currentsong: music_hls ? music_hls : music_icecast,
    downoladUrl: null,
    namesong: null,
    songimg: null,
    playlist: [],
    item_data: null,
    is_web_rtc: true,
  };
  const playAudio = () => {
    if (!isloadind) {
      dispatch(addMusic(data));
      const playPromise = tuneIn_player.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {}).catch((error) => {});
      }
      setIsloadind(true);
      setLive_btn_clicked(true);
    } else {
      return;
    }
  };
  const stopAudio = () => {
    dispatch(
      addMusic({
        downoladUrl: null,
        namesong: null,
        songimg: null,
        playlist: [],
        is_web_rtc: false,
      })
    );
    isPaused();
    setLive_btn_clicked(false);
    tuneIn_player.pause();
  };

  const [live_btn_clicked, setLive_btn_clicked] = useState(false);
  const [curentObjSrc, setCurentObjSrc] = useState(null);
  //Janus to listeners
  var janus_listeners = null;
  var sfutest = null;
  var opaqueId = "videoroomtest-" + Janus.randomString(12);
  var feeds = [],
    feedStreams = {};
  var mypvtid = null;
  var studio_id = null;

  const createListenerRoom = () => {
    Janus.init({
      debug: false,
      dependencies: Janus.useDefaultDependencies({ adapter: adapter }),
      callback: () => {
        janus_listeners = new Janus({
          server: REACT_APP_JANUS_SERVER,
          success: function () {
            janus_listeners.attach({
              plugin: "janus.plugin.videoroom",
              opaqueId: opaqueId,
              success: function (pluginHandle) {
                sfutest = pluginHandle;
                Janus.log(
                  "Plugin attached! (" +
                    sfutest.getPlugin() +
                    ", id=" +
                    sfutest.getId() +
                    ")"
                );
                Janus.log("  -- This is a publisher/manager");
                let transaction = Janus.randomString(12);
                let register = {
                  request: "join",
                  room: parseInt(radio_id),
                  ptype: "publisher",
                  display: "studio",
                  transaction: transaction,
                };
                sfutest.send({ message: register });
              },
              error: function (error) {
                Janus.error("  -- Error attaching plugin...", error);
              },
              onmessage: function (msg, jsep) {
                Janus.debug(" ::: Got a message (publisher) :::", msg);
                let event = msg["videoroom"];
                Janus.debug("Event: " + event);
                if (event) {
                  if (event === "joined") {
                    // Publisher/manager created, negotiate WebRTC and attach to existing feeds, if any
                    mypvtid = msg["private_id"];
                    // Any new feed to attach to?
                    if (msg["publishers"]) {
                      let list = msg["publishers"];
                      Janus.debug(
                        "Got a list of available publishers/feeds:",
                        list
                      );
                      for (let f in list) {
                        if (list[f]["dummy"]) continue;
                        let id = list[f]["id"];
                        let streams = list[f]["streams"];
                        let display = list[f]["display"];
                        studio_id = id;
                        for (let i in streams) {
                          let stream = streams[i];
                          stream["id"] = id;
                          stream["display"] = display;
                        }
                        feedStreams[id] = streams;
                        Janus.debug(
                          "  >> [" + id + "] " + display + ":",
                          streams
                        );
                        newRemoteFeed(id, display, streams);
                      }
                    }
                  } else if (event === "event") {
                    // Any info on our streams or a new feed to attach to?
                    if (msg["publishers"]) {
                      let list = msg["publishers"];
                      Janus.debug(
                        "Got a list of available publishers/feeds:",
                        list
                      );
                      for (let f in list) {
                        if (list[f]["dummy"]) continue;
                        let id = list[f]["id"];
                        let display = list[f]["display"];
                        let streams = list[f]["streams"];
                        studio_id = id;
                        for (let i in streams) {
                          let stream = streams[i];
                          stream["id"] = id;
                          stream["display"] = display;
                        }
                        feedStreams[id] = streams;
                        Janus.debug(
                          "  >> [" + id + "] " + display + ":",
                          streams
                        );
                        newRemoteFeed(id, display, streams);
                      }
                    } else if (msg["leaving"]) {
                      // One of the publishers has gone away?
                      let leaving = msg["leaving"];
                      if (msg["leaving"] === studio_id) {
                        let transaction = Janus.randomString(12);
                        let register = {
                          request: "leave",
                          room: parseInt(radio_id),
                          transaction: transaction,
                        };
                        sfutest.send({ message: register });
                      }
                      Janus.log("Publisher left: " + leaving);
                      let remoteFeed = null;
                      for (let i = 1; i < 6; i++) {
                        if (feeds[i] && feeds[i].rfid == leaving) {
                          remoteFeed = feeds[i];
                          break;
                        }
                      }
                      if (remoteFeed) {
                        Janus.debug(
                          "Feed " +
                            remoteFeed.rfid +
                            " (" +
                            remoteFeed.rfdisplay +
                            ") has left the room, detaching"
                        );
                        $("#video-preview").empty();
                        feeds[remoteFeed.rfindex] = null;
                        remoteFeed.detach();
                      }
                      delete feedStreams[leaving];
                    } else if (msg["error"]) {
                      if (msg["error_code"] === 426) {
                        // This is a "no such room" error: give a more meaningful description
                        console.log("Apparently room does not exist...");
                      } else {
                        console.log(msg["error"]);
                      }
                    }
                  }
                }
                if (jsep) {
                  Janus.debug("Handling SDP as well...", jsep);
                  sfutest.handleRemoteJsep({ jsep: jsep });
                  // Check if any of the media we wanted to publish has
                  // been rejected (e.g., wrong or unsupported codec)
                }
              },
              oncleanup: function () {
                Janus.log(
                  " ::: Got a cleanup notification: we are unpublished now :::"
                );
              },
            });
          },
          error: (err) => {
            console.log("errr", err);
          },
        });
      },
    });
  };
  function newRemoteFeed(id, display, streams) {
    // A new feed has been published, create a new plugin handle and attach to it as a subscriber
    let remoteFeed = null;
    if (!streams) streams = feedStreams[id];
    janus_listeners.attach({
      plugin: "janus.plugin.videoroom",
      opaqueId: opaqueId,
      success: function (pluginHandle) {
        remoteFeed = pluginHandle;
        remoteFeed.remoteTracks = {};
        remoteFeed.remoteVideos = 0;
        remoteFeed.simulcastStarted = false;
        remoteFeed.svcStarted = false;
        Janus.log(
          "Plugin attached! (" +
            remoteFeed.getPlugin() +
            ", id=" +
            remoteFeed.getId() +
            ")"
        );
        Janus.log("  -- This is a subscriber");
        // Prepare the streams to subscribe to, as an array: we have the list of
        // streams the feed is publishing, so we can choose what to pick or skip
        let subscription = [];
        for (let i in streams) {
          let stream = streams[i];
          // If the publisher is VP8/VP9 and this is an older Safari, let's avoid video
          if (
            stream.type === "video" &&
            Janus.webRTCAdapter.browserDetails.browser === "safari" &&
            (stream.codec === "vp9" ||
              (stream.codec === "vp8" && !Janus.safariVp8))
          ) {
            console.log(
              "Publisher is using " +
                stream.codec.toUpperCase +
                ", but Safari doesn't support it: disabling video stream #" +
                stream.mindex
            );
            continue;
          }
          subscription.push({
            feed: stream.id, // This is mandatory
            mid: stream.mid, // This is optional (all streams, if missing)
          });
          // FIXME Right now, this is always the same feed: in the future, it won't
          remoteFeed.rfid = stream.id;
          remoteFeed.rfdisplay = display;
        }
        // We wait for the plugin to send us an offer
        let transaction = Janus.randomString(12);
        let subscribe = {
          request: "join",
          room: parseInt(radio_id),
          ptype: "subscriber",
          streams: subscription,
          transaction: transaction,
          use_msid: false,
          private_id: mypvtid,
        };
        remoteFeed.send({ message: subscribe });
      },
      error: function (error) {
        Janus.error("  -- Error attaching plugin...", error);
        console.log("Error attaching plugin... " + error);
      },
      slowLink: function (uplink, lost, mid) {
        Janus.warn(
          "Janus reports problems " +
            (uplink ? "sending" : "receiving") +
            " packets on mid " +
            mid +
            " (" +
            lost +
            " lost packets)"
        );
      },
      onmessage: function (msg, jsep) {
        Janus.debug(" ::: Got a message (subscriber) :::", msg);
        let event = msg["videoroom"];
        Janus.debug("Event: " + event);
        if (msg["error"]) {
          console.log(msg["error"]);
        } else if (event) {
          if (event === "attached") {
            // Subscriber created and attached
            for (let i = 1; i < 6; i++) {
              if (!feeds[i]) {
                feeds[i] = remoteFeed;
                remoteFeed.rfindex = i;
                break;
              }
            }
            Janus.log("Successfully attached to feed in room " + msg["room"]);
          }
        }
        if (jsep) {
          Janus.debug("Handling SDP as well...", jsep);
          let stereo = jsep.sdp.indexOf("stereo=1") !== -1;
          // Answer and attach
          remoteFeed.createAnswer({
            jsep: jsep,
            // We only specify data channels here, as this way in
            // case they were offered we'll enable them. Since we
            // don't mention audio or video tracks, we autoaccept them
            // as recvonly (since we won't capture anything ourselves)
            tracks: [{ type: "data" }],
            customizeSdp: function (jsep) {
              if (stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                // Make sure that our offer contains stereo too
                jsep.sdp = jsep.sdp.replace(
                  "useinbandfec=1",
                  "useinbandfec=1;stereo=1"
                );
              }
            },
            success: function (jsep) {
              Janus.debug("Got SDP!", jsep);
              let body = { request: "start", room: parseInt(radio_id) };
              remoteFeed.send({ message: body, jsep: jsep });
              const rpElement = document.getElementById(`rp${id}`);
              rpElement?.querySelector(".fallback-spinner")?.remove();
            },
            error: function (error) {
              Janus.error("WebRTC error:", error);
              console.log("WebRTC error... " + error.message);
            },
          });
        }
      },
      onremotetrack: function (track, mid, on, metadata) {
        Janus.debug(
          "Remote feed #" +
            remoteFeed.rfindex +
            ", remote track (mid=" +
            mid +
            ") " +
            (on ? "added" : "removed") +
            (metadata ? " (" + metadata.reason + ") " : "") +
            ":",
          track
        );
        Janus.debug("metadatametadata", metadata);
        if (!on) {
          // Track removed, get rid of the stream and the rendering
          if (track.kind === "video") {
            remoteFeed.remoteVideos--;
            if (remoteFeed.remoteVideos === 0) {
              // No video, at least for now: show a placeholder
              console.log("remoteFeed.remoteVideos === 0");
            }
          }
          delete remoteFeed.remoteTracks[mid];
          return;
        }
        if (track.kind === "audio") {
          // New audio track: create a stream out of it, and use a hidden <audio> element
          let stream = new MediaStream([track]);
          remoteFeed.remoteTracks[mid] = stream;
          Janus.log("Created remote audio stream:", stream);
          setCurentObjSrc(stream);
          if (remoteFeed.remoteVideos === 0) {
            // No video, at least for now: show a placeholder
            console.log("remoteFeed.remoteVideos === 0");
          }
        } else {
          // New video track: create a stream out of it
          remoteFeed.remoteVideos++;
          let stream = new MediaStream([track]);
          remoteFeed.remoteTracks[mid] = stream;
          Janus.log("Created remote video stream:", stream);
          setCurentObjSrc(stream);
        }
      },
      oncleanup: function () {
        Janus.log(
          " ::: Got a cleanup notification (remote feed " + id + ") :::"
        );
        remoteFeed.simulcastStarted = false;
        remoteFeed.remoteTracks = {};
        remoteFeed.remoteVideos = 0;
      },
    });
  }
  //Janus to listeners
  useEffect(() => {
    onAir ? createListenerRoom() : setCurentObjSrc();
  }, [onAir]);

  useEffect(() => {
    var videoPreview = document.getElementById("video-preview");
    var tuneIn_player = document.getElementById("tuneIn_player");
    if (live_btn_clicked && onAir) {
      videoPreview.srcObject = curentObjSrc;
      const playPromise = videoPreview.play();
      if (playPromise != undefined) {
        playPromise.then((_) => {}).catch((error) => {});
      }
      videoPreview.hidden = false;
    } else {
      videoPreview.hidden = true;
      videoPreview.srcObject = null;
    }
    tuneIn_player.onpause = (event) => {
      setLive_btn_clicked(false);
    };
    tuneIn_player.onplay = (event) => {
      if (PlayerFrontOfficeReducer.is_web_rtc) {
        setLive_btn_clicked(true);
      } else {
        setLive_btn_clicked(false);
      }
    };
  }, [onAir, live_btn_clicked, curentObjSrc, PlayerFrontOfficeReducer]);

  return (
    <div className="banner__4">
      {onAir ? <TuneInChat /> : null}
      {BannerReducer ? (
        <Swiper {...params}>
          {BannerReducer?.BannerSections?.map((item, i) => (
            <div key={i}>
              {item.status === 1 ? (
                <SwiperSlide style={{ width: "100%", height: "100%" }} key={i}>
                  {item.type.name === "Text" ? (
                    <div className="banner_bg_home">
                      <a
                        href={item.link_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="banner-content">
                              <h1>{item.title}</h1>
                              <p>{item.details}</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  ) : item.type.name === "Picture" ? (
                    <div className="box4 effect5">
                      <img
                        src={item.file && item.file}
                        alt="swiper 1"
                        style={{ width: "100%", height: "450px" }}
                        className="banner_bg_img"
                      />
                      <div className="banner_bg_home">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="banner-content">
                              <h1>{item.title}</h1>
                              <p>{item.details}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <video
                      src={item.file}
                      autoPlay
                      muted
                      style={{
                        width: "50%",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  )}
                </SwiperSlide>
              ) : null}
            </div>
          ))}
        </Swiper>
      ) : null}
      <div className="centered">
        <div className="content">
          <div className="onAir">
            <span>{onAir && "ON AIR"}</span>
          </div>
          {next_episode ? (
            <Fragment>
              <h1>{next_episode?.name}</h1>
              <h2>{next_episode?.emission?.name}</h2>
              <h4>
                {new Date(next_episode?.start_datetime).toLocaleTimeString()} -{" "}
                {new Date(next_episode?.end_datetime).toLocaleTimeString()}
              </h4>
              <h5>duration:{secondsToTime(next_episode?.duration_sec)}</h5>
            </Fragment>
          ) : (
            namesong
          )}
          <div className="slider_btn ">
            <div className="lang_apply_btn">
              <ul>
                <li>
                  {isloadind ? (
                    <a>
                      <Spinner color="white" size="sm" />
                      <span className="ms-50">Loading...</span>
                    </a>
                  ) : (
                    <a
                      onClick={() => {
                        !isloadind && playerPause ? playAudio() : stopAudio();
                      }}
                    >
                      {!isloadind && playerPause ? (
                        <i className="flaticon-play-button" />
                      ) : (
                        <PauseCircle className="me-1" size={25} />
                      )}
                      {!isloadind && playerPause ? "Listen to live" : "Pause"}
                    </a>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
